var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReplaceDevice = function SvgReplaceDevice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1127_89251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4929 34.4025C24.4051 34.1609 24.1754 34 23.9183 34H1.37242C0.94808 34 0.652752 34.4216 0.797766 34.8204L5.39115 47.4522H29.2383L24.4929 34.4025Z",
    fill: "url(#paint0_linear_1127_89251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 -3H96.5L86 53H12.5L0.5 -3Z",
    fill: "url(#paint1_linear_1127_89251)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 47.4531H91.6072V89.0327C91.6072 92.4098 88.8696 95.1474 85.4925 95.1474H11.5053C8.12824 95.1474 5.39062 92.4098 5.39062 89.0327V47.4531Z",
    fill: "url(#paint2_linear_1127_89251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0664 47.4531L91.6078 47.4531V89.0327C91.6078 92.4098 88.8702 95.1474 85.4932 95.1474H68.0664V47.4531Z",
    fill: "url(#paint3_linear_1127_89251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5071 34.4025C72.5949 34.1609 72.8246 34 73.0817 34H95.6276C96.0519 34 96.3472 34.4216 96.2022 34.8204L91.6089 47.4522H67.7617L72.5071 34.4025Z",
    fill: "url(#paint4_linear_1127_89251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39145 47.4531H67.7609L64.5552 60.2756C64.283 61.3644 63.3047 62.1283 62.1824 62.1283H4.85526C3.26405 62.1283 2.0965 60.6329 2.48242 59.0892L5.39145 47.4531Z",
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4297,
    y: 52.3438,
    width: 17.121,
    height: 4.89172,
    rx: 1.22293,
    fill: "#8BCAFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 28,
    r: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 38,
    r: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 18.5,
    r: 1.5,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 34,
    r: 2,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 8,
    r: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20.5,
    r: 0.5,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13.5,
    r: 0.5,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 21.5,
    r: 0.5,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 11.5,
    r: 0.5,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 41.5,
    r: 1.5,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 16.5,
    r: 1.5,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 38,
    r: 1,
    fill: "#1DE9B6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1127_89251",
    x1: 14.6822,
    y1: 34,
    x2: 9.57978,
    y2: 71.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1127_89251",
    x1: 48.5,
    y1: -1,
    x2: 48.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7FFEB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64FFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1127_89251",
    x1: 48.1932,
    y1: 53.8735,
    x2: 48.9472,
    y2: 95.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1127_89251",
    x1: 79.99,
    y1: 47.4531,
    x2: 70.2065,
    y2: 96.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1127_89251",
    x1: 82.3178,
    y1: 34,
    x2: 87.4202,
    y2: 71.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1127_89251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReplaceDevice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "replace-device.35f1c3733a9e80a92d72b9a0465c14fb.svg";